import styled from "@emotion/styled";
import Container from "@mui/material/Container";

export const StyledContainer = styled(Container)`
  max-width: 1505px;
`;